import { BreadcrumbService } from './../services/breadcrumb.service';
import { Colegio } from './../interfaces/colegio';
import { ClasesService } from './../services/clases.service';
import { ColegiosService } from './../services/colegios.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { Clases } from '../interfaces/clases';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-externo',
  templateUrl: './externo.component.html',
  styleUrls: ['./externo.component.css'],
})
export class ExternoComponent implements OnInit {
  datosUsuario: any;
  colegio: Colegio;
  clase: Clases;
  userUid: any;
  misclases: any;
  nombres: string;
  apellidos: string;
  useravatar: string;
  breadcrumb = [];
  mainUserUidDb: string;
  rolUsuario: string;
  genero: string;
  cargado: boolean = false;

  profesoresId = [];
  profesores = [];
  lang: string;
  idColegio: string = '';
  loading = false;

  constructor(
    private translate: TranslateService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private colegioService: ColegiosService,
    private clasesService: ClasesService,
    private breadService: BreadcrumbService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    if (localStorage.getItem('idioma')) {
      this.lang = localStorage.getItem('idioma');
      this.translate.setDefaultLang(this.lang);
      this.translate.use(this.lang);
    } else {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
    }

    this.breadcrumb = this.breadService.getbread();
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.authenticationService.isAuth().subscribe((auth) => {
        if (auth) {
          this.userUid = auth.uid;

          this.userService.getUserById(this.userUid).subscribe((userdata) => {
            if (userdata[0].payload.doc.data()) {
              this.mainUserUidDb = userdata[0].payload.doc.id;

              this.datosUsuario = userdata[0].payload.doc.data();

              this.nombres = this.datosUsuario.nombres;
              this.apellidos = this.datosUsuario.apellidos;

              this.useravatar = '';
              this.rolUsuario = this.datosUsuario.rol;
              this.genero = 'masculino';
              this.cargado = true;
            }
          });
        }
      });

      // this.getCurrentUser();
    } else {
      this.userUid = Userdata.payload.doc.data().uid;

      this.mainUserUidDb = Userdata.payload.doc.id;
      this.datosUsuario = Userdata.payload.doc.data();

      this.nombres = this.datosUsuario.nombres;
      this.apellidos = this.datosUsuario.apellidos;

      this.useravatar = '';
      this.rolUsuario = this.datosUsuario.rol;
      this.genero = 'masculino';

      this.cargado = true;
    }
  }

  irMagisterio() {
    this.loading = true;
    const tiempoMagisterio = moment().tz('Europe/Madrid').toDate();
    // Convertir a Timestamp si usas Firestore
    // @ts-ignore
    console.log('tiempoMagisterio', tiempoMagisterio);

    // console.log('id', this.mainUserUidDb);

    const codigoMagisterio = Array.from({ length: 16 }, () =>
      Math.random().toString(36).charAt(2)
    )
      .join('')
      .toUpperCase();
    console.log('codigoMagisterio', codigoMagisterio);

    // const magisterioInfo = {
    //   tiempoMagisterio: tiempoMagisterio,
    //   codigoMagisterio: codigoMagisterio,
    // };

    this.userService
      .editUser({ tiempoMagisterio, codigoMagisterio }, this.mainUserUidDb)
      .then(() => {
        console.log(codigoMagisterio)
        const params = new HttpParams()
          .set('codigo', codigoMagisterio)
          .set('colegio', 'externo');

        this.http
          .get<any>(
            'https://us-central1-thecampus-colegios.cloudfunctions.net/app/tokenMagisnet',
            { params },
          )
          .subscribe((data) => {
            this.loading = false;
            if (data == 'error') {
              alert(
                'Error al intentar ingresar en la página. Por favor, inténtalo de nuevo más tarde.',
              );
              return;
            }
            console.log('token', data);
            const token = data;
            window.open(
              `https://www.magisnet.com/wp-json/magisnet-sso-for-the-campus/v1/login?token=${token}`,
            );
          });
      });
  }
}
